import styled from 'styled-components';

export const MaintenanceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MessageBox = styled.div`
  text-align: center;
  //background-color: #219ad6;
  //background: #5b5b66;
  margin: 5rem 1rem;
  padding: 4rem 2rem;
  //color: #3d3935;
  //color: white;
  border-radius: 0.5rem;
  max-width: 950px;

  & > div {
    margin: 0 0 2rem 0;
  }
`;
